import $ from 'jquery';
import {
	getCookieValue,
	getConfig,
	getSessionStorage,
	setSessionStorage,
	getLocalStorage,
} from './config';
import {
	removeKey,
	skipUpsell,
	throwError,
	getIP,
	resetFormState,
	saveOrderNumberIntoList,
	debug,
	clearPhone,
	setCustomerShipState,
	setCustomerBillState,
	getCountryEnv,
	resetDebugCounter,
	reportInSlack,
	isBase64,
	buildQuery,
	handleFinishedOrderError,
} from './utils';
import {
	setCustomerShipCountry,
	setCustomerBillCountry,
} from './international';
import {
	getOrdersList,
	isIndex,
} from './actions';
import {
	ORDER_ICON_PLACEHOLDER,
} from './constants';
import { buildPageUrl, normalizePageName, getFunnelScope } from './routing';
import { partitionParams, HANDOFF_STORAGE_KEY } from './pii';
import {
	useCheckoutGateway,
	gatewayRequest,
	getOrderIdempotencyKey,
	clearOrderIdempotencyKey,
} from './checkoutGateway';
import {
	hasSubscribeIds,
	resolveOrderProductId,
	isRefusedSubscribeId,
	SUBSCRIBE_ID_ERROR,
} from './subscribeProduct';
import {
	isSapphireMode,
	sapphireCartRefusal,
	sapphireProductParams,
	sapphireThankYouUrl,
} from './sapphire';
import { getSapphireCart } from './sapphireCart';


const ignoreCoupon = false;

// Signature of the last quick lead we successfully sent, used to skip
// redundant /leads/import calls when no field value actually changed.
var lastQuickLeadSignature = '';


/* -- CONTACT FORM -- */
$('#contactModal').on('hidden.bs.modal', function(e) {
	$('#sForm #sFormSuccess').remove();
	$('#sFormContainer').slideDown();
})
let formCalled = 0;
export const sFormProcess = () => {
	if (++formCalled == 1) {
		$('#sForm').append('<div id="sFormOverlay"><div id="sFormProcessor"><div><img src="data:image/gif;base64,R0lGODlhIAAgAPMAAP///wAAAMbGxoSEhLa2tpqamjY2NlZWVtjY2OTk5Ly8vB4eHgQEBAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAIAAgAAAE5xDISWlhperN52JLhSSdRgwVo1ICQZRUsiwHpTJT4iowNS8vyW2icCF6k8HMMBkCEDskxTBDAZwuAkkqIfxIQyhBQBFvAQSDITM5VDW6XNE4KagNh6Bgwe60smQUB3d4Rz1ZBApnFASDd0hihh12BkE9kjAJVlycXIg7CQIFA6SlnJ87paqbSKiKoqusnbMdmDC2tXQlkUhziYtyWTxIfy6BE8WJt5YJvpJivxNaGmLHT0VnOgSYf0dZXS7APdpB309RnHOG5gDqXGLDaC457D1zZ/V/nmOM82XiHRLYKhKP1oZmADdEAAAh+QQJCgAAACwAAAAAIAAgAAAE6hDISWlZpOrNp1lGNRSdRpDUolIGw5RUYhhHukqFu8DsrEyqnWThGvAmhVlteBvojpTDDBUEIFwMFBRAmBkSgOrBFZogCASwBDEY/CZSg7GSE0gSCjQBMVG023xWBhklAnoEdhQEfyNqMIcKjhRsjEdnezB+A4k8gTwJhFuiW4dokXiloUepBAp5qaKpp6+Ho7aWW54wl7obvEe0kRuoplCGepwSx2jJvqHEmGt6whJpGpfJCHmOoNHKaHx61WiSR92E4lbFoq+B6QDtuetcaBPnW6+O7wDHpIiK9SaVK5GgV543tzjgGcghAgAh+QQJCgAAACwAAAAAIAAgAAAE7hDISSkxpOrN5zFHNWRdhSiVoVLHspRUMoyUakyEe8PTPCATW9A14E0UvuAKMNAZKYUZCiBMuBakSQKG8G2FzUWox2AUtAQFcBKlVQoLgQReZhQlCIJesQXI5B0CBnUMOxMCenoCfTCEWBsJColTMANldx15BGs8B5wlCZ9Po6OJkwmRpnqkqnuSrayqfKmqpLajoiW5HJq7FL1Gr2mMMcKUMIiJgIemy7xZtJsTmsM4xHiKv5KMCXqfyUCJEonXPN2rAOIAmsfB3uPoAK++G+w48edZPK+M6hLJpQg484enXIdQFSS1u6UhksENEQAAIfkECQoAAAAsAAAAACAAIAAABOcQyEmpGKLqzWcZRVUQnZYg1aBSh2GUVEIQ2aQOE+G+cD4ntpWkZQj1JIiZIogDFFyHI0UxQwFugMSOFIPJftfVAEoZLBbcLEFhlQiqGp1Vd140AUklUN3eCA51C1EWMzMCezCBBmkxVIVHBWd3HHl9JQOIJSdSnJ0TDKChCwUJjoWMPaGqDKannasMo6WnM562R5YluZRwur0wpgqZE7NKUm+FNRPIhjBJxKZteWuIBMN4zRMIVIhffcgojwCF117i4nlLnY5ztRLsnOk+aV+oJY7V7m76PdkS4trKcdg0Zc0tTcKkRAAAIfkECQoAAAAsAAAAACAAIAAABO4QyEkpKqjqzScpRaVkXZWQEximw1BSCUEIlDohrft6cpKCk5xid5MNJTaAIkekKGQkWyKHkvhKsR7ARmitkAYDYRIbUQRQjWBwJRzChi9CRlBcY1UN4g0/VNB0AlcvcAYHRyZPdEQFYV8ccwR5HWxEJ02YmRMLnJ1xCYp0Y5idpQuhopmmC2KgojKasUQDk5BNAwwMOh2RtRq5uQuPZKGIJQIGwAwGf6I0JXMpC8C7kXWDBINFMxS4DKMAWVWAGYsAdNqW5uaRxkSKJOZKaU3tPOBZ4DuK2LATgJhkPJMgTwKCdFjyPHEnKxFCDhEAACH5BAkKAAAALAAAAAAgACAAAATzEMhJaVKp6s2nIkolIJ2WkBShpkVRWqqQrhLSEu9MZJKK9y1ZrqYK9WiClmvoUaF8gIQSNeF1Er4MNFn4SRSDARWroAIETg1iVwuHjYB1kYc1mwruwXKC9gmsJXliGxc+XiUCby9ydh1sOSdMkpMTBpaXBzsfhoc5l58Gm5yToAaZhaOUqjkDgCWNHAULCwOLaTmzswadEqggQwgHuQsHIoZCHQMMQgQGubVEcxOPFAcMDAYUA85eWARmfSRQCdcMe0zeP1AAygwLlJtPNAAL19DARdPzBOWSm1brJBi45soRAWQAAkrQIykShQ9wVhHCwCQCACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiRMDjI0Fd30/iI2UA5GSS5UDj2l6NoqgOgN4gksEBgYFf0FDqKgHnyZ9OX8HrgYHdHpcHQULXAS2qKpENRg7eAMLC7kTBaixUYFkKAzWAAnLC7FLVxLWDBLKCwaKTULgEwbLA4hJtOkSBNqITT3xEgfLpBtzE/jiuL04RGEBgwWhShRgQExHBAAh+QQJCgAAACwAAAAAIAAgAAAE7xDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfZiCqGk5dTESJeaOAlClzsJsqwiJwiqnFrb2nS9kmIcgEsjQydLiIlHehhpejaIjzh9eomSjZR+ipslWIRLAgMDOR2DOqKogTB9pCUJBagDBXR6XB0EBkIIsaRsGGMMAxoDBgYHTKJiUYEGDAzHC9EACcUGkIgFzgwZ0QsSBcXHiQvOwgDdEwfFs0sDzt4S6BK4xYjkDOzn0unFeBzOBijIm1Dgmg5YFQwsCMjp1oJ8LyIAACH5BAkKAAAALAAAAAAgACAAAATwEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GGl6NoiPOH16iZKNlH6KmyWFOggHhEEvAwwMA0N9GBsEC6amhnVcEwavDAazGwIDaH1ipaYLBUTCGgQDA8NdHz0FpqgTBwsLqAbWAAnIA4FWKdMLGdYGEgraigbT0OITBcg5QwPT4xLrROZL6AuQAPUS7bxLpoWidY0JtxLHKhwwMJBTHgPKdEQAACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GAULDJCRiXo1CpGXDJOUjY+Yip9DhToJA4RBLwMLCwVDfRgbBAaqqoZ1XBMHswsHtxtFaH1iqaoGNgAIxRpbFAgfPQSqpbgGBqUD1wBXeCYp1AYZ19JJOYgH1KwA4UBvQwXUBxPqVD9L3sbp2BNk2xvvFPJd+MFCN6HAAIKgNggY0KtEBAAh+QQJCgAAACwAAAAAIAAgAAAE6BDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfYIDMaAFdTESJeaEDAIMxYFqrOUaNW4E4ObYcCXaiBVEgULe0NJaxxtYksjh2NLkZISgDgJhHthkpU4mW6blRiYmZOlh4JWkDqILwUGBnE6TYEbCgevr0N1gH4At7gHiRpFaLNrrq8HNgAJA70AWxQIH1+vsYMDAzZQPC9VCNkDWUhGkuE5PxJNwiUK4UfLzOlD4WvzAHaoG9nxPi5d+jYUqfAhhykOFwJWiAAAIfkECQoAAAAsAAAAACAAIAAABPAQyElpUqnqzaciSoVkXVUMFaFSwlpOCcMYlErAavhOMnNLNo8KsZsMZItJEIDIFSkLGQoQTNhIsFehRww2CQLKF0tYGKYSg+ygsZIuNqJksKgbfgIGepNo2cIUB3V1B3IvNiBYNQaDSTtfhhx0CwVPI0UJe0+bm4g5VgcGoqOcnjmjqDSdnhgEoamcsZuXO1aWQy8KAwOAuTYYGwi7w5h+Kr0SJ8MFihpNbx+4Erq7BYBuzsdiH1jCAzoSfl0rVirNbRXlBBlLX+BP0XJLAPGzTkAuAOqb0WT5AH7OcdCm5B8TgRwSRKIHQtaLCwg1RAAAOwAAAAAAAAAAAA==" alt="" /></div><p>Processing</p></div></div>');
		console.log(formCalled);
		const url = String(getConfig().contactFormURL || '').trim();
		if (!url) {
			console.warn('[konnektive-one] sFormProcess: contactFormURL is not configured');
			$('#sFormOverlay').remove();
			formCalled = 0;
			return;
		}
		const callSettings = {
			url,
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				sFormAutoFillProtection: $('#sFormAutoFillProtection').val(),
				sFormOfferPage: document.location.pathname.replace(/^[/]?/, '').split('/')[0],
				sFormName: $('#sFormName').val(),
				sFormEmail: $('#sFormEmail').val(),
				sFormPhone: $('#sFormPhone').val(),
				sFormSubject: $('#sFormSubject').val(),
				sFormComments: $('#sFormComments').val(),
				sFormAgentInfo: window.navigator.userAgent
			}),
		};

		$.ajax(callSettings)
			.done((data) => {
				debug(data);
				if (data.success) {
					var timer = setTimeout(function() {
						$('#sForm button[type="submit"]').show();
						$('#sForm #sFormOverlay').remove();
						$('#sForm')[0].reset();
						$('#sFormContainer').slideUp('slow', function() {
							$('#sForm').append('<div id="sFormSuccess" class="alert alert-success">Message was sent. We will contact you shortly.</div>');
						});
					}, 1000);
				}
			}).fail((jqXHR, textStatus, error) => {
				console.log(`Mailer Error: `, textStatus, error);
				$('#sForm #sFormOverlay').remove();
				$('#sForm button[type="submit"]').show();
			});
	}
}
/* -- CONTACT FORM -- */

/* ------------------------------------------------------------------------------------------------- */
/*  CHECKOUT-GATEWAY HELPERS  */
// Used only when the funnel sets checkoutGatewayURL (see useCheckoutGateway).
// Ported from konnektive-engine ver-4 (0.4.11).

// Failure handler for gateway calls. Two kinds of rejection reach it: an XHR
// (gateway answered with an error status, or the network failed) and an Error
// (Turnstile could not produce a token, so nothing was sent).
function onGatewayFail(fallbackMessage) {
	return (err) => {
		debug((err && err.responseJSON) || err);
		resetFormState();
		if (err instanceof Error) {
			throwError('error', 'We could not verify your browser. Please refresh the page and try again.');
			return;
		}
		throwError('error', (err && err.responseJSON && err.responseJSON.message) || fallbackMessage);
	};
}

// Each gateway session takes one click. A 409 means this session already
// moved past the click stage (e.g. the shipping page clicked, then the lead
// re-clicks before importing) — continue with a null response.
//
// An explicit Deferred, not a .then failure filter: on jQuery < 3 (the engine
// runs on the page's jQuery) a failure filter that returns a value keeps the
// chain rejected, so the 409 would still surface as "Click failed".
function gatewayClick(body) {
	const result = $.Deferred();
	gatewayRequest('click', body)
		.done((response) => result.resolve(response))
		.fail((xhr) => {
			if (xhr && xhr.status === 409) {
				debug('gateway ' + body.pageType + ' click already advanced; continuing');
				result.resolve(null);
				return;
			}
			result.reject(xhr);
		});
	return result.promise();
}

function gatewayLeadPageClick() {
	return gatewayClick({
		pageType: 'leadPage',
		fraudPixel: 0,
		httpReferer: getSessionStorage('globalRef') || '',
		requestUri: window.location.href,
	});
}

// The gateway sets campaign and IP from its own session, so ipAddress is not
// sent from the browser.
function gatewayLeadBody(leadData) {
	const body = buildLeadParams(leadData);
	delete body.ipAddress;
	return body;
}

// G-8 / R1 + R11: an order names no existing record and no pay source. The
// gateway attaches the lead it created on this session and sets paySource
// to CREDITCARD itself. ASSUMPTION (G-8): /order ignores (does not refuse) a
// missing orderId/customerId — it already ignores them (not on its allowlist).
// Email and phone come from the lead reply; if #6 trims that reply (R2) they
// fall back to what the shopper typed, so the order never goes out without them.
function gatewayOrderBody(purchaseData, formPhone) {
	delete purchaseData.orderId;
	delete purchaseData.customerId;
	delete purchaseData.paySource;
	if (!purchaseData.emailAddress) {
		purchaseData.emailAddress = $('#cEmail').val();
	}
	if (!purchaseData.phoneNumber) {
		purchaseData.phoneNumber = formPhone;
	}
	return purchaseData;
}

// G-8: what the browser keeps of the /order reply. Only the three fields the
// library reads (render bonus1 postback, upsells, thank-you descriptor), the
// ones design §6 lists for /order. Site scripts that read other fields of
// konnektivePurchaseData get nothing for them in gateway mode.
function gatewayPurchaseData(message) {
	const m = message || {};
	const kept = { orderId: m.orderId, totalAmount: m.totalAmount };
	if (Array.isArray(m.items)) {
		kept.items = m.items.map((item) => ({ descriptor: item && item.descriptor }));
	}
	return kept;
}

// Gateway click responses carry the Konnektive session the gateway opened;
// page pixels read it from here. Since G-8 the presell click is a gateway
// click too, so no direct presell reply can overwrite it.
function saveGatewayKonnektiveSession(response) {
	if (response && response.message && response.message.sessionId) {
		sessionStorage.setItem('konnektiveSessionID', response.message.sessionId);
	}
}

// Sapphire cart (1.6.1): the saved cart lines, freshly loaded.
function sapphireCartLines() {
	const cart = getSapphireCart();
	cart.loadCart();
	return cart.getCart().cart || [];
}

// Stop a Sapphire order before anything is sent: the shopper sees why, the
// order button comes back, and the page can react to the event
// (detail: { reason, message }).
function refuseSapphireCart(refusal) {
	debug('Sapphire cart refused: ' + refusal.reason);
	resetFormState();
	document.dispatchEvent(new CustomEvent('konnektive:sapphire-cart-refused', { detail: refusal }));
	throwError('error', refusal.message);
}

/* ------------------------------------------------------------------------------------------------- */
/*  KONNEKTIVE FUNCTIONS  */

// Returns the request so render() can wait for the session before the
// checkout-page click on one-page funnels.
export function doPresellPage() {

	if(document.referrer){
		var referrer = new URL(document.referrer).hostname;
	} else {
		var referrer = '';
	}

	if (useCheckoutGateway()) {
		// G-8: the landing-page click goes to the gateway (lambda-functions#23),
		// which fills in the campaign and IP from its own session.
		// ASSUMPTION (G-8): /click accepts pageType 'presellPage' with the same
		// body as the lead/checkout clicks, and refuses a second presell click
		// on a session with 409 (handled by gatewayClick as "continue").
		// A failed landing-page click never shows the shopper an error: it is
		// tracking only, and the lead/checkout clicks open the session anyway.
		// Still returns a promise: render() waits on it before the next click.
		return gatewayClick({
			pageType: 'presellPage',
			fraudPixel: 0,
			httpReferer: referrer,
			requestUri: window.location.href,
		}).done((response) => {
			setSessionStorage('globalRef', referrer);
			if (response) {
				saveGatewayKonnektiveSession(response);
				if (response.result != "SUCCESS") {
					debug(response);
				}
			}
		}).fail((err) => debug((err && err.responseJSON) || err));
	}

	const settings = {
		url: `${getConfig().konnektiveAPIURL}/landers/clicks/import?` + buildQuery({
			pageType: 'presellPage',
			ipAddress: getIP(),
			campaignId: getConfig().products[0].campaignID_konnektive,
			httpReferer: referrer,
			requestUri: window.location.href,
		}),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': ''
		}
	};

	return $.ajax(settings).done((response) => {
		if (response.result == "SUCCESS") {
			sessionStorage.setItem('konnektiveSessionID', response.message.sessionId);
			debug("Konnektive session ID: " + response.message.sessionId);
			setSessionStorage('globalRef', referrer);
			if(referrer){
				debug("Referrer captured: " + referrer);
			} else {
				debug("Referrer unknown");
			}
		} else {
			debug(response);
			resetFormState();
			throwError('error', response.message);
		}
	})
}


function onLeadPageClick(response) {
	if (response.result == "SUCCESS") {
		sessionStorage.setItem('konnektiveAffVals', response.message.affVals);
		if (response.message.affVals) {
			debug("Konnektive Affiliate Variables:" + response.message.affVals);
		}
	} else {
		debug(response);
		resetFormState();
		throwError('error', response.message);
	}
}

export function doLeadPage() {
	if (useCheckoutGateway()) {
		gatewayLeadPageClick()
			.done((response) => {
				if (response) {
					saveGatewayKonnektiveSession(response);
					onLeadPageClick(response);
				}
			})
			.fail(onGatewayFail('Click failed'));
		return;
	}

	var referrer = getSessionStorage('globalRef');
	const settings = {
		url: `${getConfig().konnektiveAPIURL}/landers/clicks/import?` + buildQuery({
			pageType: 'leadPage',
			ipAddress: getIP(),
			campaignId: getConfig().products[0].campaignID_konnektive,
			httpReferer: referrer,
			requestUri: window.location.href,
		}),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
		}
	};

	$.ajax(settings).done(onLeadPageClick);
}

// Shared param builder for the /leads/import calls (doImportLead + doUpdateLead).
// Returns a flat object; buildQuery() handles URL-encoding of every value.
function buildLeadParams(leadData) {
	const params = {
		ipAddress: getIP(),
		campaignId: getConfig().products[0].campaignID_konnektive,
		address1: leadData.address1,
		address2: leadData.address2,
		city: leadData.city,
		country: leadData.country,
		emailAddress: leadData.emailAddress,
		firstName: leadData.firstName,
		lastName: leadData.lastName,
		phoneNumber: leadData.phoneNumber,
		postalCode: leadData.postalCode,
		custom1: leadData.custom1,
		custom2: leadData.custom2,
		custom3: leadData.custom3,
		custom4: leadData.custom4,
		custom5: parseInt(leadData.custom5),
		custom_sessionID: leadData.custom_sessionID,
		custom_customer_age: leadData.custom_customer_age,
		custom_customer_gender: leadData.custom_customer_gender,
		custom_issue_type: leadData.custom_issue_type,
		custom_issue_value: leadData.custom_issue_value,
		custom_lpURL: leadData.custom_lpURL,
		custom_billing_model: leadData.custom_billing_model,
		custom_product_selection: leadData.custom_product_selection,
		custom_sms: leadData.custom_sms,
		custom_userAgent: leadData.custom_userAgent,
		custom_ipAddress: leadData.custom_ipAddress,
		custom_salesUrl: leadData.custom_salesUrl,
		custom_contactOptIn: leadData.custom_contactOptIn,
		contactOptIn: leadData.contactOptIn,
		emailOptIn: leadData.emailOptIn,
		marketingOptIn: leadData.marketingOptIn,
		billShipSame: 'Y',
		state: leadData.state,
		product1_id: leadData.product1_id,
		variant1_id: leadData.variant1_id,
	};
	// Sapphire cart (1.6.1): the lead carries the cart lines with their
	// quantities instead of one config product, so the partial order holds
	// the same products as the order. Only Sapphire leads set sapphireLines.
	if (leadData.sapphireLines) {
		delete params.product1_id;
		delete params.variant1_id;
		Object.assign(params, sapphireProductParams(leadData.sapphireLines));
	}
	return params;
}

// Hand the shipping form over to the checkout page.
//
// The legacy path was a native GET submit (document.shipping_form.submit()),
// which serialises every field into the checkout URL — name, email, phone and
// street address, sitting in the address bar, in browser history, and in any
// outbound referrer. Under the default 'session' transport we split the form:
// PII is parked in sessionStorage and everything else stays in the query
// string, so product selection, promo codes, chash prefill and affiliate /
// click-tracking params survive the hop untouched.
export function submitShippingForm() {
	const form = document.shipping_form;
	if (!form) {
		return;
	}

	if (getConfig().urlPiiTransport !== 'session') {
		form.submit();
		return;
	}

	const pairs = $(form).serializeArray().map(({ name, value }) => [name, value]);
	const { pii, passThrough } = partitionParams(pairs, getConfig().piiFields);

	// Tag the handoff with the page it is FOR. Without this, render() would
	// re-apply it on every page for the rest of the session — so going back to
	// select and starting again would land on a shipping form pre-filled with
	// the previous run's details. It must be consumed by the checkout page only.
	const target = new URL(form.action, window.location.href);

	try {
		// Raw sessionStorage on purpose, paired with a raw read in render().
		//
		// setSessionStorage() tests `content !== 'string'` — comparing the
		// VALUE to the literal "string" rather than its typeof — so it
		// JSON.stringify()s anything, including an already-serialised string,
		// producing a double-encoded blob. Passing the object would round-trip
		// fine, but keeping both ends raw makes the encoding explicit and
		// independent of that quirk.
		sessionStorage.setItem(HANDOFF_STORAGE_KEY, JSON.stringify({
			target: normalizePageName(target.pathname),
			// The page name alone is ambiguous on a domain running more than one
			// funnel: '/checkout.html' and '/ngos1/checkout.html' both normalise
			// to 'checkout', so one funnel's handoff could hydrate the other's
			// checkout. Pin the funnel too.
			scope: getFunnelScope(target.pathname),
			fields: pii,
		}));
	} catch (e) {
		// Storage blocked or full. Falling back to the native submit puts PII
		// back in the URL — no better than before, but never a dead-ended
		// checkout. The rest of the flow needs sessionStorage anyway.
		debug('PII handoff storage failed, falling back to query transport: ' + e);
		form.submit();
		return;
	}

	// Funnel pages sometimes pre-load the action with the current query string,
	// so form.action can already carry one. A native GET submit REPLACES the
	// action's query with the serialised fields rather than appending to it —
	// match that, or the params arrive doubled behind a second '?'. Nothing is
	// lost: render() hydrated those params into the form, so they are already
	// in passThrough.
	target.search = $.param(passThrough);

	window.location.assign(target.toString());
}

export function doImportLead(leadData, checkoutType) {
	const onLeadImport = (response) => {
		if (response.result == "SUCCESS") {
			sessionStorage.setItem('konnektiveLeadData', JSON.stringify(response.message));
			debug("Konnektive Lead Data: " + response.message);
			debug("Checkout type: " + checkoutType);
			if (checkoutType == "generic") { // regular two-page checkout
				submitShippingForm();
			}
			if (checkoutType == "onepage") { // one-page checkout
				doCompleteOrder();
			}
			if (checkoutType == "sapphire") { // sapphire checkout
				doCompleteOrderSapphire();
			}
		} else {
			debug(response);
			resetFormState();
			throwError('error', response.message);
		}
	};

	if (useCheckoutGateway()) {
		// Click first: the gateway rejects a lead on a session that has not
		// clicked, and the shipping page's own click may still be in flight.
		gatewayLeadPageClick()
			.then((clickResponse) => {
				if (clickResponse) {
					saveGatewayKonnektiveSession(clickResponse);
					onLeadPageClick(clickResponse);
				}
				return gatewayRequest('lead', gatewayLeadBody(leadData));
			})
			.done(onLeadImport)
			.fail(onGatewayFail('Lead failed'));
		return;
	}

	const settings = {
		url: `${getConfig().konnektiveAPIURL}/leads/import?` + buildQuery(buildLeadParams(leadData)),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
		}
	};

	$.ajax(settings).done(onLeadImport);
}

// experiment //
export function doUpdateLead(leadData) {

	// Changed-value guard: every field blur calls this, so bail out when the
	// data is identical to the last lead we sent. Prevents redundant requests.
	const leadSignature = JSON.stringify(leadData);
	if (leadSignature === lastQuickLeadSignature) {
		debug("Quick lead unchanged since last send. Skipping.");
		return;
	}

	// Reuse the orderId returned by the first /leads/import so Konnektive
	// updates the existing partial instead of creating a new one on each blur.
	const existingOrderId = sessionStorage.getItem('quick_lead_order_id');

	const onUpdate = (response) => {
		if (response.result == "SUCCESS") {
			debug("Konnektive Lead Data: ");
			debug(response.message);
			// Remember the orderId + signature only on success so failed
			// sends are retried and the next change updates the same partial.
			if (response.message && response.message.orderId) {
				sessionStorage.setItem('quick_lead_order_id', response.message.orderId);
			}
			lastQuickLeadSignature = leadSignature;
		} else {
			debug(response);
		}
	};

	if (useCheckoutGateway()) {
		// G-8 / R1: no orderId. The browser never names a record; the gateway
		// keeps the partial it created on its own session.
		// /lead reuses the partial order it created on this session
		// (lambda-functions#11, live); any page-sent orderId is ignored.
		const body = gatewayLeadBody(leadData);
		// Background save — a failure stays silent here, as on the direct path;
		// the submit-time lead import surfaces any real error.
		gatewayLeadPageClick()
			.then((clickResponse) => {
				if (clickResponse) {
					saveGatewayKonnektiveSession(clickResponse);
					if (clickResponse.result == "SUCCESS") {
						onLeadPageClick(clickResponse);
					} else {
						debug(clickResponse);
					}
				}
				return gatewayRequest('lead', body);
			})
			.done(onUpdate)
			.fail((err) => debug((err && err.responseJSON) || err));
		return;
	}

	let url = `${getConfig().konnektiveAPIURL}/leads/import?` + buildQuery(buildLeadParams(leadData));
	if (existingOrderId) {
		url += `&orderId=` + existingOrderId;
	}

	const settings = {
		url: url,
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
		}
	};

	$.ajax(settings).done(onUpdate);
}
// experiment //

export function konnektive_new_lead(checkoutType = "generic") {

	let issueType = '';
	let issueValue = '';
	let age = 0;
	let gender = '';

	if ($('#cIssueType').length) {
		issueType = $('#cIssueType').val();
	}
	if ($('#cIssueValue').length) {
		issueValue = $('#cIssueValue').val();
	}
	if ($('#cAge').length) {
		age = $('#cAge').val();
	}
	if ($('#cGender').length) {
		gender = $('#cGender').val();
	}

	var productID = 0;
	var variantID = 0;
	var productSelectedIndex = $('#cBillProductIndex').val();
	var purchaseType = $('#cBillPurchaseType').val();

	// Sapphire cart (1.6.1): the products are the cart lines, not a config
	// product picked by #cBillProductIndex (blank on Sapphire checkouts).
	const sapphireLines = checkoutType === 'sapphire' ? sapphireCartLines() : null;

	if(productSelectedIndex && !sapphireLines){
		const product = getConfig().products[productSelectedIndex];
		productID = resolveOrderProductId(product, purchaseType, $('#cBillSubscribeIndex').val());
		// Core configs only: a subscribe pick with no real product id (0
		// placeholder) stops here instead of booking product 0.
		if (isRefusedSubscribeId(product, purchaseType, productID)) {
			resetFormState();
			throwError('error', SUBSCRIBE_ID_ERROR);
			return;
		}
	}

	if(!sapphireLines && getConfig().products[productSelectedIndex].vid_konnektive){
		variantID = getConfig().products[productSelectedIndex].vid_konnektive;
	}

	var leadData = {
		"address1": $('#cShipAddress1').val(),
		"address2": $('#cShipAddress2').val(),
		"city": $('#cShipCity').val(),
		"country": $('#cShipCountry').val(),
		"emailAddress": $('#cEmail').val(),
		"firstName": $('#cShipFName').val(),
		"lastName": $('#cShipLName').val(),
		"phoneNumber": $('#cPhone2').val(),
		"postalCode": $('#cShipZip').val(),
		"state": $('#cShipState').val(),
		"product1_id": productID,
		"variant1_id": variantID,
		"custom_sessionID": getLocalStorage('session_id'),
		"custom_customer_age": age,
		"custom_customer_gender": gender,
		"custom_issue_type": issueType,
		"custom_issue_value": issueValue,
		"custom_lpURL": getSessionStorage('lp_url'),
		"custom_billing_model": $('#cBillPurchaseType').val(),
		"custom_product_selection": $('#cBillProductIndex').val(),
		"custom_userAgent": navigator.userAgent,
		"custom_ipAddress": getCookieValue('ip'),
		"custom_salesUrl": document.location.href,
		"custom_contactOptIn": "0",
		"contactOptIn": "0",
		"marketingOptIn": "0",
		"emailOptIn": "0",
		"custom1": issueType,
		"custom2": issueValue,
		"custom3": age,
		"custom4": gender,
		"custom5": $('#cBillProductIndex').val()
	}

	if (sapphireLines) {
		leadData.sapphireLines = sapphireLines;
	}

	if($('#cSMSOption').length) {
		if($('#cSMSOption').prop('checked')){
			leadData.custom_sms = 'optin';
			leadData.custom_contactOptIn = 1;			
			leadData.contactOptIn = 1;			
			leadData.marketingOptIn = 1;			
		} else {
			leadData.custom_sms = 'optout';
			leadData.custom_contactOptIn = 0;			
			leadData.contactOptIn = 0;			
			leadData.marketingOptIn = 0;			
		}
	} else {
			leadData.custom_contactOptIn = 0;			
			leadData.contactOptIn = 0;			
			leadData.marketingOptIn = 0;						
	}

	if($('#cEmailOption').length) {
		if($('#cEmailOption').prop('checked')){
			leadData.custom_emailOptIn = 1;			
			leadData.emailOptIn = 1;			
		} else {
			leadData.custom_emailOptIn = 0;			
			leadData.emailOptIn = 0;			
		}
	} else {
			leadData.custom_emailOptIn = 0;			
			leadData.emailOptIn = 0;			
	}


	doImportLead(leadData, checkoutType);
}

export function doCheckoutPage() {
	var referrer = getSessionStorage('globalRef');
	if(!referrer){
		if(document.referrer){
			var referrer = new URL(document.referrer).hostname;
		} else {
			var referrer = '';
		}
	}

	const onCheckoutPageClick = (response) => {
		if (response.result == "SUCCESS") {
			$("body").append(response.message.pixel);
			debug(response.message.pixel);
			debug("Referrer captured: " + referrer);
			sessionStorage.setItem('konnektiveAffVals', response.message.affVals);
			if (response.message.affVals) {
				debug("Konnektive Affiliate Variables:" + response.message.affVals);
			}
		} else {
			debug(response);
			resetFormState();
			throwError('error', response.message);
		}
	};

	if (useCheckoutGateway()) {
		gatewayClick({
			pageType: 'checkoutPage',
			fraudPixel: 1,
			httpReferer: referrer,
			requestUri: window.location.href,
		})
			.done((response) => {
				if (response) {
					saveGatewayKonnektiveSession(response);
					onCheckoutPageClick(response);
				}
			})
			.fail(onGatewayFail('Click failed'));
		return;
	}

	const settings = {
		url: `${getConfig().konnektiveAPIURL}/landers/clicks/import?` + buildQuery({
			pageType: 'checkoutPage',
			ipAddress: getIP(),
			campaignId: getConfig().products[0].campaignID_konnektive,
			httpReferer: referrer,
			fraudPixel: '1',
			requestUri: window.location.href,
		}),
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
		}
	};

	$.ajax(settings).done(onCheckoutPageClick);
}

export function doCompleteOrder() {

	var leadResponseInfo = [];
	var konnektiveLeadData = $.parseJSON(sessionStorage.getItem('konnektiveLeadData'));
	if (konnektiveLeadData) { // making sure that we have a previously got LEAD DATA
		leadResponseInfo = konnektiveLeadData;

		const productSelectedIndex = $('#cBillProductIndex').val();
		const purchaseType = $('#cBillPurchaseType').val();
		const country = getCountryEnv('cShipCountry');

		sessionStorage.setItem('country_env', country);
		sessionStorage.setItem('selectedIndex', productSelectedIndex);
		sessionStorage.setItem('purchaseType', purchaseType);

		if (getConfig().international[0][country]) {
			var shippingCost = getConfig().international[0][country][0].shipping;
		} else {
			var shippingCost = getConfig().international[0]["all"][0].shipping;
		}

		let billingSameAsShipping = $('#billEqualShip').val() === 'Y' ? 'YES' : 'NO';
		if ($('#billEqualShip').val() === 'on') { // fallback if no value was defined
			if ($('#billEqualShip').prop('checked')) {
				billingSameAsShipping = 'Y';
			} else {
				billingSameAsShipping = 'N';
			}
		}

		if ($('#billEqualShip').prop('checked')) {
			billingSameAsShipping = 'Y';
		}

		const selectedProduct = getConfig().products[productSelectedIndex];
		const subscribeIndex = $('#cBillSubscribeIndex').val();
		let productID = resolveOrderProductId(selectedProduct, purchaseType, subscribeIndex);
		// Core configs only: never send a subscribe order for product 0.
		if (isRefusedSubscribeId(selectedProduct, purchaseType, productID)) {
			resetFormState();
			throwError('error', SUBSCRIBE_ID_ERROR);
			return;
		}
		if (hasSubscribeIds(selectedProduct)) {
			// doAddUpsell's voidMain path needs the frequency the main order used.
			sessionStorage.setItem('subscribeIndex', subscribeIndex || 0);
		}

		var variantID = 0;
		if(getConfig().products[productSelectedIndex].vid_konnektive){
			variantID = getConfig().products[productSelectedIndex].vid_konnektive;
		} 

		if(getConfig().products[productSelectedIndex].shippingID){
			var shippingProfile = getConfig().products[productSelectedIndex].shippingID;
		}

		let cPhoneNumber = clearPhone($('#cPhone2').val());

		let issueType = '';
		let issueValue = '';
		let age = 0;
		let gender = '';

		if ($('#cIssueType').length) {
			issueType = $('#cIssueType').val();
		}
		if ($('#cIssueValue').length) {
			issueValue = $('#cIssueValue').val();
		}
		if ($('#cAge').length) {
			age = $('#cAge').val();
		}
		if ($('#cGender').length) {
			gender = $('#cGender').val();
		}

		setSessionStorage('customer_age', age);
		setSessionStorage('customer_gender', gender);
		setSessionStorage('customer_issue_type', issueType);
		setSessionStorage('customer_issue_value', issueValue);

		const customer_age = getSessionStorage('customer_age');
		const customer_gender = getSessionStorage('customer_gender');
		const customer_issue_type = getSessionStorage('customer_issue_type');
		const customer_issue_value = getSessionStorage('customer_issue_value');

		let promoCode = $('#cBillPromoCode').val() === '' ? '' : $('#cBillPromoCode').val();
		if (ignoreCoupon) {
			promoCode = '';
		}

		const purchaseData = {
			address1: $("#cBillAddress1").val(),
			address2: $("#cBillAddress2").val(),
			billShipSame: billingSameAsShipping,
			city: $("#cBillCity").val(),
			state: $("#cBillState").val(),
			country: $("#cBillCountry").val(),
			customerId: leadResponseInfo.customerId,
			orderId: leadResponseInfo.orderId,
			emailAddress: leadResponseInfo.emailAddress,
			firstName: $("#cBillFName").val(),
			ipAddress: getIP(),
			lastName: $("#cBillLName").val(),
			paySource: "CREDITCARD",
			phoneNumber: leadResponseInfo.phoneNumber,
			postalCode: $("#cBillZip").val(),
			shipAddress1: $("#cShipAddress1").val(),
			shipAddress2: $("#cShipAddress2").val(),
			shipCity: $("#cShipCity").val(),
			shipCountry: $("#cShipCountry").val(),
			shipFirstName: $("#cShipFName").val(),
			shipLastName: $("#cShipLName").val(),
			shipPostalCode: $("#cShipZip").val(),
			shipState: $("#cShipState").val(),
			campaignId: getConfig().products[productSelectedIndex].campaignID_konnektive,
			cardNumber: $('#ccNum').val(),
			cardMonth: $("#ccMonth").val(),
			cardSecurityCode: $('#ccCode').val(),
			cardYear: $("#ccYear").val(),
			product1_id: productID,
			variant1_id: variantID,
			product1_qty: 1,
			custom_sessionID: getLocalStorage('session_id'),
			custom_customer_age: customer_age,
			custom_customer_gender: customer_gender,
			custom_issue_type: customer_issue_type,
			custom_issue_value: customer_issue_value,
			custom_lpURL: getSessionStorage('lp_url'),
			custom_billing_model: $('#cBillPurchaseType').val(),
			custom_product_selection: productSelectedIndex,
			custom1: customer_issue_type,
			custom2: customer_issue_value,
			custom3: customer_age,
			custom4: customer_gender,
			custom5: productSelectedIndex,
		};

		if($('#cSMSOption').length) {
			purchaseData.custom_sms = $('#cSMSOption').prop('checked') ? 'optin' : 'optout';
		}

		if(promoCode){
			purchaseData.couponCode = promoCode;
		}

		if (useCheckoutGateway()) {
			gatewayOrderBody(purchaseData, cPhoneNumber);
		}

		const promoGift = $('#cBillGift').length !== 0;

		const onOrder = (response) => {
			// An answer (approved, or a decline — Konnektive sends both as HTTP
			// 200) retires the idempotency key, so the shopper's next attempt is a
			// new order rather than a replay. Any HTTP failure (.fail) keeps it:
			// a retry is deduped, and an upstream timeout the gateway stored under
			// the key replays until an index reload (outcome unknown, so no
			// second charge).
			clearOrderIdempotencyKey();
			if (response.result == "SUCCESS") { // MAIN ORDER COMPLETED
				sessionStorage.setItem('konnektivePurchaseData', JSON.stringify(
					useCheckoutGateway() ? gatewayPurchaseData(response.message) : response.message));
				sessionStorage.setItem('order_id', response.message.orderId);
				debug("Konnektive PurchaseData: " + response.message);

				if (promoGift){ // LETS ADD GIFT AS AN UPSELL
					debug("Applying Free Gift Upsell...");
					const onGift = (gift_response) => {
						if (gift_response.result == "SUCCESS") { // GIFT OK - GOING NEXT TO BONUSES
							debug("Free Gift Applied.");
							debug(gift_response.message);
							proceedToBonuses(response.message.orderId);

						} else {
							debug("Error adding free gift.");
							debug(gift_response);
							proceedToBonuses(response.message.orderId);
						}
					};

					if (useCheckoutGateway()) {
						const giftPid = getConfig().gifts[0].pid_konnektive;
						// orderId is the one #6 just returned for this session's
						// order (S-6 refuses any other); exactly one product.
						gatewayRequest('upsell', {
							productId: giftPid,
							orderId: response.message.orderId,
							product1_id: giftPid,
							product1_qty: 1,
						}, undefined, { existingSessionOnly: true })
							.done(onGift)
							// The main order is placed; a lost gift must not strand the shopper.
							.fail(() => proceedToBonuses(response.message.orderId));
					} else {
						const gift_settings = {
							url: `${getConfig().konnektiveAPIURL}/upsale/import?productId=` + getConfig().gifts[0].pid_konnektive +
								"&orderId=" + response.message.orderId,
							method: 'POST',
							timeout: 0,
							headers: {
								'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
							}
						};

						$.ajax(gift_settings).done(onGift);
					}

						// LETS ADD GIFT AS AN UPSELL
				} else { // NO GIFT ADDED. PROCEED TO BONUSES
					proceedToBonuses(response.message.orderId);
					// NO GIFT ADDED. PROCEED TO BONUSES
				}

			} else { // MAIN ORDER ERRORS
				debug(response);
				resetFormState();
				throwError('error', response.message);
			}
		};

		if (useCheckoutGateway()) {
			// JSON body, not a query string: card details stay out of the URL.
			gatewayRequest('order', purchaseData, { 'X-Idempotency-Key': getOrderIdempotencyKey('order') })
				.done(onOrder)
				.fail(onGatewayFail('Order failed'));
			return;
		}

		const settings = {
			url: getConfig().konnektiveAPIURL + "/order/import?" + buildQuery(purchaseData),
			method: "POST",
			timeout: 0,
			headers: {
				'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
			}
		};

		$.ajax(settings).done(onOrder);


	} else {
		//throwError('error', 'No lead data found. Please begin from the index page.', './');
		konnektive_new_lead('onepage');
	}
}

export function doAddUpsell() {
	var purchaseResponseInfo = $.parseJSON(sessionStorage.getItem('konnektivePurchaseData'));
	const { upsellIndex } = getConfig();

	if (useCheckoutGateway()) {
		doAddUpsellViaGateway(purchaseResponseInfo);
		return;
	}

	var addUpsellURL = `${getConfig().konnektiveAPIURL}/upsale/import?productId=` + getConfig().upsells[getConfig().upsellIndex].pid_konnektive +
	"&orderId=" + purchaseResponseInfo.orderId;

	if(getConfig().upsells[getConfig().upsellIndex].vid_konnektive){
		addUpsellURL = `${getConfig().konnektiveAPIURL}/upsale/import?productId=` + getConfig().upsells[getConfig().upsellIndex].pid_konnektive +
		"&product1_id=" + getConfig().upsells[getConfig().upsellIndex].pid_konnektive + "&variant1_id=" + getConfig().upsells[getConfig().upsellIndex].vid_konnektive + "&orderId=" + purchaseResponseInfo.orderId;
	}

	const settings = {
		url: addUpsellURL,
		method: 'POST',
		timeout: 0,
		headers: {
			'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
		}
	};

	if(getConfig().upsells[getConfig().upsellIndex].voidMain){
	// check if main purchase trial needs to be replaced by this upsell
		var productSelectedIndex = sessionStorage.getItem('selectedIndex');
		var prodIndex = resolveOrderProductId(getConfig().products[productSelectedIndex],
			sessionStorage.getItem('purchaseType'), sessionStorage.getItem('subscribeIndex'));
		if(getConfig().products[productSelectedIndex].isTrial) {
			settings.url += '&replaceProductId=' + prodIndex;
		}
	}

	const onUpsell = (response) => {
		if (response.result == "SUCCESS") {
			debug(response.message);

			if(getConfig().upsells[getConfig().upsellIndex].voidMain){
			// check if main purchase needs to be voided by this upsell
				debug("Retail upsell taken. Replacing the Trial one.");
				var productSelectedIndex = sessionStorage.getItem('selectedIndex');
				var prodIndex = resolveOrderProductId(getConfig().products[productSelectedIndex],
					sessionStorage.getItem('purchaseType'), sessionStorage.getItem('subscribeIndex'));
				if(getConfig().products[productSelectedIndex].isTrial) {

// LET'S REFUND MAIN PRODUCT TXN AFTER UPSELL IS TAKEN 

					const curTransactionsInfoSettings = {
						url: `${getConfig().konnektiveAPIURL}/transactions/query?orderId=` + purchaseResponseInfo.orderId,
						method: 'POST',
						timeout: 0,
						headers: {
							'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
						}
					}

					$.ajax(curTransactionsInfoSettings).done((response) => {
						if (response.result == "SUCCESS") {
							var transactionIDToBeVoided = response.message.data[0].transactionId;
							debug("TxnID to be voided: " + transactionIDToBeVoided);
								const voidMainProdTransSettings = {
									url: `${getConfig().konnektiveAPIURL}/transactions/refund?transactionId=` + transactionIDToBeVoided +
										"&fullRefund=true" + 
										"&cancelPurchase=true" + 
										"&cancelReason=Retail upsell taken",
									method: 'POST',
									timeout: 0,
									headers: {
										'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
									}
								};
								$.ajax(voidMainProdTransSettings).done((response) => {
									if (response.result == "SUCCESS") {
										debug("Main product TXN voided successfully. Moving forward.");
                                                                                skipUpsell();
									} else {
										debug(response.message);
										resetFormState();
										throwError('error', "Error canceling trial product. Please call us at " + getConfig().servicePhone + " so we can assist you in placing your order.");
									}
								});

						} else { 	// TXN not found. weird!
							debug(response.message);
							resetFormState();
							throwError("error", "Can't get current order info. Please call us at " + getConfig().servicePhone + " so we can assist you in placing your order.");
						}
					})

// LET'S REFUND MAIN PRODUCT TXN AFTER UPSELL IS TAKEN 

				} else {
					debug(response);
					skipUpsell();
				}
			} else {
				debug(response);
				skipUpsell();
			}

		} else {
			debug(response);
			resetFormState();
			skipUpsell();
		}
	};

	$.ajax(settings).done(onUpsell);
}

// G-8 upsell through the gateway.
//  - orderId: only the one #6 returned for this session's /order (stored in
//    konnektivePurchaseData), never the ?orderID= in the page address. S-6
//    refuses any other; with none stored it is left out and #6 uses its own.
//  - exactly one product: productId == product1_id, never product2..4.
//  - never opens a new session (a new session has no order to add to).
//  - trial replacement (voidMain on a trial main product): send
//    replaceProductId = the trial's product id. That field is what makes the
//    gateway refund the trial's payment once the upsell succeeds, when the id
//    is one of the trial products its /order stored (lambda-functions#16/#31,
//    live). The browser makes no /transactions/* call. Do not drop it: without
//    it the shopper keeps both the trial charge and the full-price charge.
function doAddUpsellViaGateway(purchaseResponseInfo) {
	const upsell = getConfig().upsells[getConfig().upsellIndex];
	const upsellBody = {
		productId: upsell.pid_konnektive,
		product1_id: upsell.pid_konnektive,
		product1_qty: 1,
	};
	if (purchaseResponseInfo && purchaseResponseInfo.orderId) {
		upsellBody.orderId = purchaseResponseInfo.orderId;
	}
	if (upsell.vid_konnektive) {
		upsellBody.variant1_id = upsell.vid_konnektive;
	}

	if (upsell.voidMain) {
		const productSelectedIndex = sessionStorage.getItem('selectedIndex');
		const mainProduct = getConfig().products[productSelectedIndex];
		if (mainProduct && mainProduct.isTrial) {
			upsellBody.replaceProductId = resolveOrderProductId(mainProduct,
				sessionStorage.getItem('purchaseType'), sessionStorage.getItem('subscribeIndex'));
		}
	}

	gatewayRequest('upsell', upsellBody, undefined, { existingSessionOnly: true })
		.done((response) => {
			debug(response);
			if (!response || response.result != "SUCCESS") {
				resetFormState();
			}
			skipUpsell();
		})
		.fail((err) => {
			// Same outcome as a declined upsell: move the shopper on.
			debug((err && err.responseJSON) || err);
			resetFormState();
			skipUpsell();
		});
}


export function konnektive_get_images() {
	if (isIndex()) { // cleanup procedure for homepages
		sessionStorage.removeItem('imagesList');
	}
	var storageImageData = getSessionStorage('imagesList');
	if (!storageImageData) {
		var storageImageData = [];
		$.each(getConfig().products, (i, entry) => {
			storageImageData.push([{
				pid: entry.pid_konnektive,
				url: '',
			}]);
			if (hasSubscribeIds(entry)) {
				// Core config: one subscription product per delivery frequency.
				$.each(entry.subscribeIds_konnektive, (si, subscribeId) => {
					storageImageData.push([{
						pid: subscribeId,
						url: '',
					}]);
				});
			} else {
				storageImageData.push([{
					pid: entry.pid_konnektive_ss,
					url: '',
				}]);
			}
		});
		$.each(getConfig().upsells, (i, entry) => {
			storageImageData.push([{
				pid: entry.pid_konnektive,
				url: '',
			}]);
		});
		$.each(getConfig().gifts, (i, entry) => {
			storageImageData.push([{
				pid: entry.pid_konnektive,
				url: '',
			}]);
		});
		storageImageData.push([{
			pid: getConfig().shipProtection[0].pid_konnektive,
			url: '',
		}]);
		setSessionStorage('imagesList', JSON.stringify(storageImageData));
	} else {
		storageImageData = JSON.parse(storageImageData);
	}

	// get all campaign images

	var campaignData = '';
	// G-8: the gateway's /campaign-images answers for the session's campaign
	// in Konnektive's /campaign/query shape (campaignProductId + imageUrl only).
	let imagesRequest;
	if (useCheckoutGateway()) {
		imagesRequest = gatewayRequest('campaign-images', {});
	} else {
		imagesRequest = $.ajax({
			url: `${getConfig().konnektiveAPIURL}/campaign/query?campaignId=` + getConfig().products[0].campaignID_konnektive,
			method: 'POST',
			timeout: 0,
			headers: {
				'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
			}
		});
	}
	imagesRequest.fail((err) => {
		debug('Campaign images unavailable');
		debug((err && err.responseJSON) || err);
	});
	imagesRequest.done((response) => {
		if (response.result == "SUCCESS") { // check if there's an image
			const byCampaign = (response.message && response.message.data) || {};
			const campaign = byCampaign[getConfig().products[0].campaignID_konnektive];
			campaignData = (campaign && campaign.products) || [];
			$.each(storageImageData, (i, product) => {
				if (!product[0].url) { // no URL detected - will make some API calls
					$.each(campaignData, (pi, prd) => {
						if (prd.campaignProductId == product[0].pid) {
							if (prd.imageUrl) {
								storageImageData[i][0].url = prd.imageUrl;
								setSessionStorage('imagesList', JSON.stringify(storageImageData));
							}
						}
					})
				} else { // URL is here. skipping...

				}
			});
		}
	});
}


export function doConfirmOrder() {
	var orderCookie = sessionStorage.getItem('konnektivePurchaseData');
	if (orderCookie) {
		var purchaseResponseInfo = $.parseJSON(sessionStorage.getItem('konnektivePurchaseData'));
		const settings = {
			url: `${getConfig().konnektiveAPIURL}/order/confirm?orderId=` + purchaseResponseInfo.orderId,
			method: 'POST',
			timeout: 0,
			headers: {
				'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
			}
		};

		$.ajax(settings).done((response) => {
			if (response.result == "SUCCESS") {
				debug("Order finalized");
			} else {
				debug(response);
				throwError('error', response.message);
			}
		});
	} else {
		handleFinishedOrderError();
	}
}


// Swap the thank-you rows' placeholder icons for the product images that
// konnektive_get_images() cached on the checkout page.
function applyThankYouImages() {
	// No cached list (e.g. the thank-you page opened in a new tab): keep the
	// placeholders rather than throw.
	let storageImageData = null;
	try {
		storageImageData = JSON.parse(getSessionStorage('imagesList'));
	} catch (e) {
		storageImageData = null;
	}
	$('.product-image').each(function() {
		const $curImage = $(this);
		const pID = parseInt($(this).attr('data-pid'));
		if (storageImageData) {
			$.each(storageImageData, (i, entry) => {
				if (parseInt(entry[0].pid) == parseInt(pID)) {
					$curImage.attr('src', entry[0].url);
				} else { // if no images were set
					if(getConfig().instance == "sapphire"){ // let's hide image for Probuilt
						$curImage.hide();
					}
				}
			});
		}
	});
}

// Fills the thank-you page from one order (direct: Konnektive's order/query
// row; gateway: the /finish thank-you fields). Shared so both modes draw the
// same rows.
function fillThankYouPage(order, purchaseResponseInfo) {
	const descriptor = (purchaseResponseInfo && purchaseResponseInfo.items && purchaseResponseInfo.items[0]
		&& purchaseResponseInfo.items[0].descriptor) || '';

	var orderInfo = '';
	var orderInfoMobile = '';
	var orderUserInfo = '';
	var orderNumbers = [];
	var orderTotal = 0;
	var orderInfoStatus = '';
	var sapOrderInfo = '';
	var sapShips = 0;

	var total = 0;

	$.each(order.items || [], (i, product) => {
		// Image lookup key. Gateway mode: the item's productId, because
		// readFinishReply() turns the keyed items into a list. Direct mode keeps
		// the item's key, exactly as 1.5 did.
		const pid = useCheckoutGateway() && product.productId !== undefined ? product.productId : i;

		if (product.purchaseCycle) {
			const recurringDate = new Date(product.nextBillDate).toString('MMM d, yyyy');
			var recurringInfo = `<br/><small>Next Shipment: ${recurringDate}</small>`;
		} else {
			var recurringInfo = '';
		}

		if (product.txnType == "VOID") {
			orderInfoStatus = 'order-voided';
		} else {
			orderInfoStatus = '';
			sapShips += parseFloat(product.shipping);
		}

		var mobilzInfo = '';
		var subtotal = parseFloat(product.price) + parseFloat(product.shipping);
		total += subtotal;

		orderInfo += `<tr class="ty-order-entry ${orderInfoStatus} order-entry-${i}">`;
		orderInfo += `<td><img src="${ORDER_ICON_PLACEHOLDER}" class="product-image" data-pid="${pid}" id="product-${i}" />${product.name.replace(/ *\([^)]*\) */g, "")}</td>`;
		orderInfo += `<td>${order.orderId}</td>`;
		orderInfo += `<td>${descriptor}</td>`;
		orderInfo += `<td>${product.qty}</td>`;
		orderInfo += `<td>$${product.price}</td>`;
		orderInfo += `<td>$${product.shipping}</td>`;
		orderInfo += `<td>$` + subtotal.toFixed(2) + `</td>`;
		orderInfo += '</tr>';

		sapOrderInfo += `<tr class="ty-order-entry ${orderInfoStatus} order-entry-${i}">`;
		sapOrderInfo += `<td><img src="${ORDER_ICON_PLACEHOLDER}" class="product-image" data-pid="${pid}" id="product-${i}" />${product.name.replace(/ *\([^)]*\) */g, "")}</td>`;
		sapOrderInfo += `<td align="right">$${product.price}</td>`;
		sapOrderInfo += `<td align="right">${product.qty}</td>`;
		sapOrderInfo += `<td align="right">$` + subtotal.toFixed(2) + `</td>`;
		sapOrderInfo += '</tr>';

		orderInfoMobile += `<tr class="ty-order-entry ${orderInfoStatus} mobile-order-entry-${i}">`;
		orderInfoMobile += `<td><strong>${product.name}</strong><div class="smallInfo"><img src="${ORDER_ICON_PLACEHOLDER}" class="product-image" data-pid="${pid}" id="product-${i}" /> Order : ${purchaseResponseInfo.orderId}<br/>Billed as: ${descriptor}<br/>Qty: ${product.qty}<br/>Shipping: $${product.shipping}</div>` + mobilzInfo + '</td>';
		orderInfoMobile += `<td>$${product.price}</td>`;
		orderInfoMobile += '</tr>';
	});

	if (parseFloat(order.totalDiscount)) {
		orderInfo += '<tr class="table-light"><td colspan="6"><strong>Discount:</strong></td><td><strong>$' + parseFloat(order.totalDiscount).toFixed(2) + '</strong></td></tr>';
		orderInfoMobile += '<tr class="table-light"><td align="right"><strong>Discount:</strong></td><td><strong>$' + parseFloat(order.totalDiscount).toFixed(2) + '</strong></td></tr>';
		total -= parseFloat(order.totalDiscount);
	}

	if (order.cardType == "TESTCARD") {
		$('#order_summary tfoot').append('<tr class="table-danger"><td colspan="7"><strong>THIS IS THE TEST ORDER</strong></td></td></tr>');
	}

	if(getConfig().instance != "sapphire"){ // let's fill regular TY page

		$('#order_number').text(order.orderId);
		$('#order_number').parent().text($('#order_number').parent().text().replace("#", ""));
		$('#fullname').text(`${order.firstName} ${order.lastName}`);
		$('#address').text(order.shipAddress1);
		$('#city_state').text(`${order.shipCity}, ${order.shipState}, ${order.shipCountry}`);
		$('#zip').text(order.shipPostalCode);

		$('#order_summary tbody').html(orderInfo);
		$('#order_summary .totals').html((parseFloat(order.totalAmount)).toFixed(2));
		$('#order_summary_mobile tbody').html(orderInfoMobile);
		$('#order_summary_mobile .totals').html((parseFloat(order.totalAmount)).toFixed(2));

	} else { // let's fill Sapphire/Probuilt TY page

		$('#order_number').text(order.orderId);
		$('#order_summary tbody').html(sapOrderInfo);
		$('#order_summary .totals').html(parseFloat(order.totalAmount).toFixed(2));

		$('#orderDiscount').html('$' + parseFloat(order.totalDiscount).toFixed(2));
		$('#orderSubTotal').html('$' + parseFloat(order.totalAmount).toFixed(2));
		$('#orderShipping').html('$' + parseFloat(sapShips).toFixed(2));
		$('#orderTotal').html('$' + parseFloat(order.totalAmount).toFixed(2));
	}
}

// G-8: the fields the thank-you page and its orderDataCallback may hold (design
// §6 /finish). Anything else #6 might send is dropped before it is stored.
// The last five are per-site extras (e.g. Rokt) #6 sends only when that site's
// gateway config asks for them.
const THANK_YOU_FIELDS = [
	'orderId', 'firstName', 'lastName', 'shipAddress1', 'shipCity', 'shipState', 'shipCountry',
	'shipPostalCode', 'totalAmount', 'totalDiscount', 'cardType',
	'emailAddress', 'phoneNumber', 'postalCode', 'country', 'paySource',
];
const THANK_YOU_ITEM_FIELDS = ['productId', 'name', 'qty', 'price', 'shipping', 'txnType', 'purchaseCycle', 'nextBillDate'];

function pickFields(source, fields) {
	const out = {};
	fields.forEach((key) => {
		if (source[key] !== undefined) {
			out[key] = source[key];
		}
	});
	return out;
}

// The gateway's /finish (lambda-functions#17) answers { result: 'SUCCESS',
// message: { data: [<thank-you fields>] } }, with items keyed the way
// Konnektive keys them and each carrying productId. The fields under message
// or at the top level are accepted too, for tolerance. Returns null when the
// reply carries no order.
function readFinishReply(reply) {
	if (!reply || (reply.result && reply.result != "SUCCESS") || reply.success === false) {
		return null;
	}
	let raw = reply.message;
	if (raw && Array.isArray(raw.data)) {
		raw = raw.data[0];
	}
	if (!raw || typeof raw !== 'object') {
		raw = reply;
	}
	if (!raw.orderId) {
		return null;
	}
	const order = pickFields(raw, THANK_YOU_FIELDS);
	// Konnektive's /order/query returns items as an object keyed by id; accept a
	// list too. Either way they become a list here.
	let items = [];
	if (Array.isArray(raw.items)) {
		items = raw.items;
	} else if (raw.items && typeof raw.items === 'object') {
		items = Object.values(raw.items);
	}
	order.items = items.map((item) => pickFields(item || {}, THANK_YOU_ITEM_FIELDS));
	return order;
}

// The order was placed and paid; a failed summary must not leave the shopper
// behind a spinner or an error. Show what the browser already knows.
function showThankYouFallback(purchaseResponseInfo) {
	resetFormState();
	$('#order_number').text(purchaseResponseInfo.orderId);
	const total = parseFloat(purchaseResponseInfo.totalAmount);
	// Global isNaN on purpose (same result for a parseFloat value): a
	// Number.isNaN here trips babel-plugin-minify-builtins ("Couldn't find
	// intersection") and fails the webpack build.
	if (!isNaN(total)) {
		$('#order_summary .totals, #order_summary_mobile .totals').html(total.toFixed(2));
		if (getConfig().instance == "sapphire") {
			$('#orderTotal').html('$' + total.toFixed(2));
		}
	}
}

// G-8 thank-you step: one /finish call replaces /order/confirm and /order/query
// on #7 (lambda-functions#17). No order id is sent: #6 uses the order its own
// session placed, sends Konnektive's confirmation email once per session, and
// answers with the thank-you fields only. Uses the existing session and never
// opens a new one (a new session has no order).
function finalizeOrdersViaGateway() {
	const purchaseResponseInfo = $.parseJSON(sessionStorage.getItem('konnektivePurchaseData'));
	if (!purchaseResponseInfo) {
		handleFinishedOrderError();
		return;
	}

	gatewayRequest('finish', {}, undefined, { existingSessionOnly: true })
		.done((response) => {
			const order = readFinishReply(response);
			if (!order) {
				debug(response);
				showThankYouFallback(purchaseResponseInfo);
				return;
			}
			sessionStorage.setItem('konnektiveOrderData', JSON.stringify(order));
			debug(order);
			if (typeof orderDataCallback == 'function') {
				debug("Callback found. Executing...");
				orderDataCallback(order);
			}
			fillThankYouPage(order, purchaseResponseInfo);
			resetFormState();
			applyThankYouImages();
		})
		.fail((err) => {
			debug((err && err.responseJSON) || err);
			showThankYouFallback(purchaseResponseInfo);
		});
}

export function konnektive_finalize_orders() {
	if (useCheckoutGateway()) {
		finalizeOrdersViaGateway();
		return;
	}

	doConfirmOrder();

	var purchaseResponseInfo = $.parseJSON(sessionStorage.getItem('konnektivePurchaseData'));
	if (purchaseResponseInfo) {

		const settings = {
			url: `${getConfig().konnektiveAPIURL}/order/query?orderId=` + purchaseResponseInfo.orderId,
			method: 'POST',
			timeout: 0,
			headers: {
				'X-SESSION-ID': '' // sessionStorage.getItem('konnektiveSessionID')
			}
		};

		$.ajax(settings).done((response) => {
			if (response.result == "SUCCESS") {

				var order = response.message.data[0];
				sessionStorage.setItem('konnektiveOrderData', JSON.stringify(order));
				debug(order);

				if ( typeof orderDataCallback == 'function' ) { 
					debug("Callback found. Executing...");
					orderDataCallback(order);
				} else {
					debug("No order callback set.");
				}


				fillThankYouPage(order, purchaseResponseInfo);

				resetFormState();

				applyThankYouImages();


			} else {
				debug(response);
				throwError('error', response.message);
			}
		});
	}
}


export function konnektive_get_partial(customerHash) {
	if (useCheckoutGateway()) {
		// G-8: abandoned-cart pre-fill is skipped until signed links ship
		// (G-6, lambda-functions#22 /recover). No request anywhere; the form
		// stays empty and the checkout still sells.
		resetFormState();
		debug('Cart pre-fill skipped (checkout gateway)');
		return;
	}
	try {
		var partialOrderID;
		if(isBase64(customerHash)){
			partialOrderID = atob(customerHash);
		} else {
			partialOrderID = customerHash;
		}
		
		const settings = {
			url: `${getConfig().konnektiveAPIURL}/order/query?orderId=` + partialOrderID,
			method: 'POST',
			timeout: 0,
			headers: {
				'X-SESSION-ID': '' // sessionStorage.getItem('konnektiveSessionID')
			}
		};

		$.ajax(settings).done((response) => {
			if (response.result == "SUCCESS") {
				resetFormState();
				debug(response);
				if (response.message.data[0].orderStatus == "PARTIAL") {
					konnektive_fill_ca_forms(response.message.data[0]);
				} else {
						if (response.message.data[0].orderStatus == "DECLINED") {
						throwError('error', "Order " + partialOrderID + " is declined.", './');
						}
						if (response.message.data[0].orderStatus == "COMPLETED") {
						throwError('error', "Order " + partialOrderID + " is completed.", './');
						}
						if (response.message.data[0].orderStatus == "CANCELLED") {
						throwError('error', "Order " + partialOrderID + " is cancelled.", './');
						}
				}
			} else {
				debug(response);
				//throwError('error', response.message);
			}
		});
	} catch (e) {
		resetFormState();
	}
}


export function konnektive_fill_ca_forms(response) {
	$('#cShipFName').val(response.shipFirstName);
	$('#cShipLName').val(response.shipLastName);
	$('#cShipAddress1').val(response.shipAddress1);
	$('#cShipAddress2').val(response.shipAddress2);
	$('#cShipCity').val(response.shipCity);
	$('#cShipZip').val(response.shipPostalCode);
	setCustomerShipState(response.shipState);
	setCustomerShipCountry(response.shipCountry);

	$('#cBillFName').val(response.firstName);
	$('#cBillLName').val(response.lastName);
	$('#cBillAddress1').val(response.address1);
	$('#cBillAddress2').val(response.address2);
	$('#cBillCity').val(response.city);
	$('#cBillZip').val(response.postalCode);
	setCustomerBillState(response.state);
	setCustomerBillCountry(response.country);

	$('#cPhone2').val(response.phoneNumber);
	$('#cEmail').val(response.emailAddress);

	const productIndexSelection = response.custom5;

	if (parseInt(productIndexSelection)) {
		$('#cBillProductIndex').val(productIndexSelection);

		if ($('.optionSelector').length) {
			$(`.optionSelector .selector[data-rel=${billingModelTypeSelection}]`).click();
			$(`.packageselectors .package[data-pid=${productIndexSelection}]`).click();
		}

		var ct = setTimeout(function() {
			$(`[data-package-sku=${productIndexSelection}]`).click();
			debug("Package selection restored with index :" + productIndexSelection);
		}, 1000);
	} else {
		debug("Package selection index not found");
	}

	// making false LEAD DATA object

	var pseudoLeadData = {
		"address1": response.address1,
		"address2": response.address2,
		"billShipSame": false,
		"campaignId": response.campaignId,
		"city": response.city,
		"country": response.country,
		"emailAddress": response.emailAddress,
		"firstName": response.firstName,
		"ipAddress": response.ipAddress,
		"lastName": response.lastName,
		"phoneNumber": response.phoneNumber,
		"postalCode": response.postalCode,
		"state": response.state,
		"shipFirstName": response.shipFirstName,
		"shipLastName": response.shipLastName,
		"shipAddress1": response.shipAddress1,
		"shipAddress2": response.shipAddress2,
		"shipCity": response.shipCity,
		"shipState": response.shipState,
		"shipCountry": response.shipCountry,
		"shipPostalCode": response.shipPostalCode,
		"orderStatus": response.orderStatus,
		"orderType": response.orderType,
		"customerId": response.customerId,
		"agentUserId": response.agentUserId,
		"address2": response.address2,
		"orderId": response.clientOrderId
	}

	sessionStorage.setItem('konnektiveLeadData', JSON.stringify(pseudoLeadData));
}

// Sapphire cart order (gateway: 'sapphire'). 1.6.1: refuses a cart the
// gateway would refuse or cut (more than 4 lines, another campaign), sends
// every line with its real quantity, empties the cart on success and goes to
// the configured thank-you page (sapphireThankYouPage).
export function doCompleteOrderSapphire() {
	const cartContents = sapphireCartLines();
	const refusal = sapphireCartRefusal(cartContents);
	if (refusal) {
		refuseSapphireCart(refusal);
		return;
	}

	var leadResponseInfo = [];
	var konnektiveLeadData = $.parseJSON(sessionStorage.getItem('konnektiveLeadData'));
	if (konnektiveLeadData) { // making sure that we have a previously got LEAD DATA
		leadResponseInfo = konnektiveLeadData;

		const country = getCountryEnv('cShipCountry');
		const productSelectedIndex = 0;
		const purchaseType = 'onetime';

		sessionStorage.setItem('country_env', country);
		sessionStorage.setItem('selectedIndex', productSelectedIndex);
		sessionStorage.setItem('purchaseType', purchaseType);

		if (getConfig().international[0][country]) {
			var shippingCost = getConfig().international[0][country][0].shipping;
		} else {
			var shippingCost = getConfig().international[0]["all"][0].shipping;
		}

		let billingSameAsShipping = $('#billEqualShip').val() === 'Y' ? 'YES' : 'NO';
		if ($('#billEqualShip').val() === 'on') { // fallback if no value was defined
			if ($('#billEqualShip').prop('checked')) {
				billingSameAsShipping = 'Y';
			} else {
				billingSameAsShipping = 'N';
			}
		}

		if ($('#billEqualShip').prop('checked')) {
			billingSameAsShipping = 'Y';
		}

		let cPhoneNumber = clearPhone($('#cPhone2').val());

		let issueType = '';
		let issueValue = '';
		let age = 0;
		let gender = '';
		if ($('#cIssueType').length) {
			issueType = $('#cIssueType').val();
		}
		if ($('#cIssueValue').length) {
			issueValue = $('#cIssueValue').val();
		}
		if ($('#cAge').length) {
			age = $('#cAge').val();
		}
		if ($('#cGender').length) {
			gender = $('#cGender').val();
		}

		setSessionStorage('customer_age', age);
		setSessionStorage('customer_gender', gender);
		setSessionStorage('customer_issue_type', issueType);
		setSessionStorage('customer_issue_value', issueValue);

		const customer_age = getSessionStorage('customer_age');
		const customer_gender = getSessionStorage('customer_gender');
		const customer_issue_type = getSessionStorage('customer_issue_type');
		const customer_issue_value = getSessionStorage('customer_issue_value');

		let promoCode = $('#cBillPromoCode').val() === '' ? '' : $('#cBillPromoCode').val();
		if (ignoreCoupon) {
			promoCode = '';
		}

		const purchaseData = {
			address1: $("#cBillAddress1").val(),
			address2: $("#cBillAddress2").val(),
			billShipSame: billingSameAsShipping,
			city: $("#cBillCity").val(),
			state: $("#cBillState").val(),
			country: $("#cBillCountry").val(),
			customerId: leadResponseInfo.customerId,
			orderId: leadResponseInfo.orderId,
			emailAddress: leadResponseInfo.emailAddress,
			firstName: $("#cBillFName").val(),
			ipAddress: getIP(),
			lastName: $("#cBillLName").val(),
			paySource: "CREDITCARD",
			phoneNumber: leadResponseInfo.phoneNumber,
			postalCode: $("#cBillZip").val(),
			shipAddress1: $("#cShipAddress1").val(),
			shipAddress2: $("#cShipAddress2").val(),
			shipCity: $("#cShipCity").val(),
			shipCountry: $("#cShipCountry").val(),
			shipFirstName: $("#cShipFName").val(),
			shipLastName: $("#cShipLName").val(),
			shipPostalCode: $("#cShipZip").val(),
			shipState: $("#cShipState").val(),
			campaignId: cartContents[0].itemCampaignID || getConfig().products[0].campaignID_konnektive,
			cardNumber: $('#ccNum').val(),
			cardMonth: $("#ccMonth").val(),
			cardSecurityCode: $('#ccCode').val(),
			cardYear: $("#ccYear").val(),
			custom_sessionID: getLocalStorage('session_id'),
			custom_customer_age: customer_age,
			custom_customer_gender: customer_gender,
			custom_issue_type: customer_issue_type,
			custom_issue_value: customer_issue_value,
			custom_lpURL: getSessionStorage('lp_url'),
			custom_billing_model: $('#cBillPurchaseType').val(),
			custom_product_selection: productSelectedIndex,
			custom1: customer_issue_type,
			custom2: customer_issue_value,
			custom3: customer_age,
			custom4: customer_gender,
			custom5: productSelectedIndex,
		};

		if(promoCode){
			purchaseData.couponCode = promoCode;
		}

		if (useCheckoutGateway()) {
			gatewayOrderBody(purchaseData, cPhoneNumber);
		}

		// Every cart line with its real quantity (productN_id + productN_qty,
		// N = 1..4), passed by the gateway to Konnektive's /order/import as is.
		Object.assign(purchaseData, sapphireProductParams(cartContents));

		const onSapphireOrder = (response) => {
			// Definitive answer retires the idempotency key (see doCompleteOrder).
			clearOrderIdempotencyKey();
			if (response.result == "SUCCESS") {
				sessionStorage.setItem('konnektivePurchaseData', JSON.stringify(
					useCheckoutGateway() ? gatewayPurchaseData(response.message) : response.message));
				sessionStorage.setItem('order_id', response.message.orderId);
				debug("Konnektive PurchaseData: " + response.message);
				// The order is placed: empty the cart (as demo-engine did), so the
				// shopper's next visit starts clean and a back-button resubmit has
				// nothing to send.
				const cart = getSapphireCart();
				cart.loadCart();
				if (typeof cart.emptyCart === 'function') {
					cart.emptyCart();
				}
				$(location).prop('href', sapphireThankYouUrl(response.message.orderId));
			} else {
				debug(response);
				resetFormState();
				throwError('error', response.message);
			}
		};

		if (useCheckoutGateway()) {
			gatewayRequest('order', purchaseData, { 'X-Idempotency-Key': getOrderIdempotencyKey('sapphire') })
				.done(onSapphireOrder)
				.fail(onGatewayFail('Order failed'));
			return;
		}

		const settings = {
			url: getConfig().konnektiveAPIURL + "/order/import?" + buildQuery(purchaseData),
			method: "POST",
			timeout: 0,
			headers: {
				'X-SESSION-ID': sessionStorage.getItem('konnektiveSessionID')
			}
		};

		$.ajax(settings).done(onSapphireOrder);


	} else {
//		throwError('error', 'No lead data found. Please begin from the index page.');
		debug("No lead data found. Creating the custom one.");
		konnektive_new_lead('sapphire');
	}

}


export function proceedToBonuses(order_id){
	var upsellsFolder = 'checkout';
	if(getConfig().upsellsFolder){
		upsellsFolder = getConfig().upsellsFolder;
	}
	
	const ext = getConfig().pageExtension;

	if (getConfig().enableUpsells) {
		var upsellLoc = upsellsFolder + '/' + buildPageUrl('bonus1', ext) + '?orderID=' + order_id;
		if ($('input[name="urlparams"]').val()) {
			upsellLoc += '&' + $('input[name="urlparams"]').val();
		}
		$(location).prop('href', upsellLoc);
	} else {
		$(location).prop('href', upsellsFolder + '/' + buildPageUrl('thankyou', ext) + '?' + $('input[name="urlparams"]').val());
	}
}

/* --  KONNEKTIVE FUNCTIONS -- */

// Keep a partial lead fresh as the customer fills the form: every blur on a
// shipping field re-sends, so the record in Konnektive grows with the form
// instead of only appearing at submit. doUpdateLead() dedupes identical
// payloads and reuses quick_lead_order_id, so this updates one partial rather
// than creating a pile of them.
//
// The selector used to be hard-coded to form[data-onePageCheckout="true"],
// which meant the classic two-page funnel got no partial at all — its shipping
// form never carries that attribute. Parameterised so both can bind.
const QUICK_LEAD_FIELDS = [
	'input#cEmail',
	'input#cShipFName',
	'input#cShipLName',
	'input#cShipAddress1',
	'input#cShipAddress2',
	'input#cShipCity',
	'input#cShipZip',
	'input#cPhone2',
	'select#cShipState',
];

export function konnektive_maintain_lead(formSelector = 'form[data-onePageCheckout="true"]') {


	const selector = QUICK_LEAD_FIELDS.map((field) => `${formSelector} ${field}`).join(', ');
	$(selector).blur(function() {
		sendQuickLead();
	});

}

export function sendQuickLead() {
	let issueType = '';
	let issueValue = '';
	let age = 0;
	let gender = '';

	if ($('#cIssueType').length) {
		issueType = $('#cIssueType').val();
	}
	if ($('#cIssueValue').length) {
		issueValue = $('#cIssueValue').val();
	}
	if ($('#cAge').length) {
		age = $('#cAge').val();
	}
	if ($('#cGender').length) {
		gender = $('#cGender').val();
	}

	var productID = 0;
	var productSelectedIndex = $('#cBillProductIndex').val();
	var purchaseType = $('#cBillPurchaseType').val();

	// Sapphire cart (1.6.1): save the cart lines, and only while the cart
	// could be ordered (the submit shows the refusal).
	let sapphireLines = null;
	if (isSapphireMode()) {
		sapphireLines = sapphireCartLines();
		if (sapphireCartRefusal(sapphireLines)) {
			debug('Quick lead skipped: the Sapphire cart cannot be ordered as it is.');
			return;
		}
	}

	if (productSelectedIndex && !sapphireLines) {
		const product = getConfig().products[productSelectedIndex];
		productID = resolveOrderProductId(product, purchaseType, $('#cBillSubscribeIndex').val());
		// Background save: no popup over the form. The submit-time lead
		// refuses the same pick with a visible error.
		if (isRefusedSubscribeId(product, purchaseType, productID)) {
			debug('Quick lead skipped: no subscription product for this pick.');
			return;
		}
	}

	var fakeLeadData = {
		"address1": $('#cShipAddress1').val(),
		"address2": $('#cShipAddress2').val(),
		"city": $('#cShipCity').val(),
		"country": $('#cShipCountry').val(),
		"emailAddress": $('#cEmail').val(),
		"firstName": $('#cShipFName').val(),
		"lastName": $('#cShipLName').val(),
		"phoneNumber": $('#cPhone2').val(),
		"postalCode": $('#cShipZip').val(),
		"state": $('#cShipState').val(),
		"product1_id": productID,
		"custom_sessionID": getLocalStorage('session_id'),
		"custom_customer_age": age,
		"custom_customer_gender": gender,
		"custom_issue_type": issueType,
		"custom_issue_value": issueValue,
		"custom_lpURL": getSessionStorage('lp_url'),
		"custom_billing_model": $('#cBillPurchaseType').val(),
		"custom_product_selection": $('#cBillProductIndex').val(),
		"custom1": issueType,
		"custom2": issueValue,
		"custom3": age,
		"custom4": gender,
		"custom5": $('#cBillProductIndex').val()
	}

	if (sapphireLines) {
		fakeLeadData.sapphireLines = sapphireLines;
	}

	if (fakeLeadData.firstName && fakeLeadData.lastName && fakeLeadData.emailAddress && fakeLeadData.city && fakeLeadData.address1 && fakeLeadData.state && fakeLeadData.postalCode && fakeLeadData.country) {
		doUpdateLead(fakeLeadData);
	} else {
		console.log('Not all neccessary fields are filled yet... Skipping.');
	}

}

// Auto-init: restore one-page-checkout quick-lead binding
export function initOnePageCheckout() {
	if (getConfig().provider != "konnektive") {
		return;
	}

	const isOnePageCheckout = $('form[data-onePageCheckout="true"]').length;
	if (isOnePageCheckout !== 0) {
		konnektive_maintain_lead();
	}

	// Two-page funnels: same blur-driven partial on the shipping form. Opt-in,
	// because it adds a /leads/import call per field blur and funnels that have
	// never had it should not start issuing them on a version bump.
	if (getConfig().quickLeadOnBlur && $('#shipping_form').length) {
		konnektive_maintain_lead('#shipping_form');
	}
}